/* @flow */
import invariant from 'invariant';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

// any valid phone number -> (555) 555-5555
export function format(num: string) {
  if (!num) {
    return null;
  }

  const phone = parsePhoneNumberFromString(num);

  if (!phone) {
    return num;
  }

  return phone.formatNational();
}

// 15555555555 -> 1 (555) 555-5555
export function formatWithLeading1(num: string) {
  // Numbers can have 11 digits: 1 510 555 2038
  invariant(
    num.length === 11,
    'formatWithLeading1 requires the number of length 11 so it can be formatted like `1 (510) 555-1212`, received:' +
      num
  );
  const result = num.split('').reduce((acc, value, i) => {
    const res = acc.slice(); // shallow copy
    res.push(value);
    // 1 -> 1 (
    if (i === 0) {
      res.push(' (');
    }
    // 1510 -> 1 (510)
    if (i === 3) {
      res.push(') ');
    }
    // 1510555 -> 1 (510) 555-
    if (i === 6) {
      res.push('-');
    }
    return res;
  }, []);

  return result.join('');
}

export function stripFormatting(num: string) {
  return num.replace(/[^0-9]/g, '');
}

export function stripFormattingAndLeading1(num: string) {
  return num.replace(/^\+1|[^0-9]/g, '');
}

export function stripSpaces(num: string) {
  return num.replace(/ /g, '');
}

export function ensureLeading1(num: string) {
  const cleanedValue = stripFormatting(num);
  if (!cleanedValue.startsWith('1')) {
    return '1' + cleanedValue;
  }
  return cleanedValue;
}
